;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "aganListitem",
        defaults = {
            hoverClass: "listitem--hover",
            hoverClassStart: "listitem--hover-start",
            mouseOverSelector: ".listitem-container",
            additionalInfo: ".listitem-additional-info",
            variants: ".listitem-variants",
            startpage: ".cl-start"
        };

    /**
     * Constructor
     * @param element
     * @param options
     * @constructor
     */
    function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.$element = $(element);
        this.init();
    }

    $.extend(Plugin.prototype, {

        /**
         * jquery constructor
         */
        init: function () {
            this._bindListitemHover();
        },

        /**
         * @private
         */
        _bindListitemHover: function () {
            var self = this;

            if ($('body').hasClass('cl-start')) {
                this.$element.find(this.settings.variants).on('mouseenter', function () {
                    $(this).closest('.listitem').addClass(self.settings.hoverClassStart);
                });
                this.$element.find(this.settings.mouseOverSelector).on('mouseenter', function () {
                    $(this).closest('.listitem').addClass(self.settings.hoverClassStart);
                });
                this.$element.find(this.settings.additionalInfo).on('mouseenter', function () {
                    $(this).closest('.listitem').addClass(self.settings.hoverClassStart);
                });
                this.$element.on('mouseleave', function () {
                    $(this).removeClass(self.settings.hoverClassStart);
                });
            } else {
                this.$element.find(this.settings.variants).on('mouseenter', function () {
                    $(this).closest('.listitem').addClass(self.settings.hoverClass);
                });
                this.$element.find(this.settings.mouseOverSelector).on('mouseenter', function () {
                    $(this).closest('.listitem').addClass(self.settings.hoverClass);
                });
                this.$element.find(this.settings.additionalInfo).on('mouseenter', function () {
                    $(this).closest('.listitem').addClass(self.settings.hoverClass);
                });
                this.$element.on('mouseleave', function () {
                    $(this).removeClass(self.settings.hoverClass);
                });
            }
        }
    });

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" +
                    pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);
